// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2820": "b6025241b1d2","3571": "bb0d7aea5624","4380": "c44485e5b00c","8357": "dd422574e14d",}[chunkId] + ".css"
}